'use strict';

var SeasonalityToolbarDirective = function SeasonalityToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-toolbar.html'),
    controller: 'SeasonalityToolbarController',
    scope: {
      screenState: '='
    }
  };
};
SeasonalityToolbarDirective.$inject = [];
module.exports = SeasonalityToolbarDirective;